import { createActionCreator } from 'deox';
import { Paging, Country, Currency } from '@/types';

export const fetchRegionsActions = {
  request: createActionCreator('FETCH_REGIONS_REQUEST', (resolve) => () => resolve()),
  success: createActionCreator(
    'FETCH_REGIONS_SUCCESS',
    (resolve) => (data: string[], paging: Paging) => resolve({ data, paging }),
  ),
  failure: createActionCreator('FETCH_REGIONS_FAILURE', (resolve) => (error: any) =>
    resolve({ error }),
  ),
};

export const fetchCurrenciesActions = {
  request: createActionCreator('FETCH_CURRENCIES_REQUEST', (resolve) => () => resolve()),
  success: createActionCreator(
    'FETCH_CURRENCIES_SUCCESS',
    (resolve) => (data: Currency[], paging: Paging) => resolve({ data, paging }),
  ),
  failure: createActionCreator('FETCH_CURRENCIES_FAILURE', (resolve) => (error: any) =>
    resolve({ error }),
  ),
};

export const fetchCountriesByRegionActions = {
  request: createActionCreator(
    'FETCH_COUNTRIES_BY_REGION_REQUEST',
    (resolve) => (regionName: string) => resolve({ regionName }),
  ),
  success: createActionCreator(
    'FETCH_COUNTRIES_BY_REGION_SUCCESS',
    (resolve) => (data: Country[], paging: Paging, meta: { authors: string[] }) =>
      resolve({ data, paging, meta }),
  ),
  failure: createActionCreator('FETCH_COUNTRIES_BY_REGION_FAILURE', (resolve) => (error: any) =>
    resolve({ error }),
  ),
};
